const cta = document.querySelector( '.main__wrap > .cta:last-child' );

if ( cta ) {
	cta.classList.add( 'cta-last' );
}
